<template>
  <div
      :title="$t('Time range')"
      class="range-wrapper">
    <!--    <span >{{ runningMonthRange }}</span >-->
    <q-btn
        class="range-btn"
        icon="event"
        color="secondary"
        :label="$t(displayContent)">
      <q-popup-proxy
          ref="qDateProxy"
          transition-show="scale"
          transition-hide="scale">
        <q-date
            xstyle="min-width: 550px;"
            v-model="content"
            minimal
            mask="DD/MM/YYYY"
            range
            @range-end="lastSelect">
          <div
              class="row items-center justify-end q-gutter-sm"
              v-if="isMobileDevice()">
            <q-btn
                :icon="runningMonthRange-1==nowMonth?'arrow_downward':'chevron_left'"
                class="range-btn"
                color="secondary"
                :label="months[relativeMonthRange-1<0?11:relativeMonthRange-1]"
                @click="goRange(-1)"></q-btn>

            <q-btn
                class="range-btn"
                :icon="runningMonthRange+1==nowMonth?'arrow_downward':'chevron_right'"
                :label="months[relativeMonthRange+1>11?0:relativeMonthRange+1]"

                color="secondary"
                @click="goRange(1)"></q-btn>
            <q-btn
                icon="arrow_downward"
                class="range-btn"
                color="secondary"
                :label="months[nowMonth]"
                @click="goRange()"></q-btn>
          </div>
          <div class="row items-center justify-end q-gutter-sm calendar">
            <div style="display: flex">
              <q-btn
                  size="sm"
                  class="range-btn"
                  @click="goRange(false);"
                  v-close-popup
                  :label="$t('Όλα')"
                  color="primary"
                  icon="trending_up"/>
              <q-btn
                  @click="goRange(-1,true);"
                  v-close-popup
                  size="sm"
                  class="range-btn"
                  :label="$t('Περυση')"
                  color="primary"
                  icon="trending_up"/>
              <q-btn
                  @click="goRange(0,true);"
                  v-close-popup
                  size="sm"
                  class="range-btn"
                  icon="trending_up"
                  :label="$t('Φετος')"
                  color="primary"/>
            </div>
            <!--          </div>-->
            <!--          <div class="row items-center justify-end">-->
            <q-btn
                icon="close"
                v-close-popup
                size="sm"
                lxabel="Close"
                color="primary"
                flat/>
          </div>
        </q-date>
      </q-popup-proxy>
    </q-btn>
    <template v-if="!isMobileDevice()">
      <q-btn
          :icon="runningMonthRange-1==nowMonth?'arrow_downward':'chevron_left'"
          class="range-btn"
          color="secondary"

          :label="months[relativeMonthRange-1<0?11:relativeMonthRange-1]"
          @click="goRange(-1)"></q-btn>

      <q-btn
          class="range-btn"
          :icon="runningMonthRange+1==nowMonth?'arrow_downward':'chevron_right'"
          :label="months[relativeMonthRange+1>11?0:relativeMonthRange+1]"

          color="secondary"
          @click="goRange(1)"></q-btn>
      <q-btn
          v-if="(relativeMonthRange-1<0?11:relativeMonthRange-1)!=nowMonth&&(relativeMonthRange+1>11?0:relativeMonthRange+1)!=nowMonth"
          icon="arrow_downward"
          class="range-btn"
          color="secondary"
          :label="months[nowMonth]"
          @click="goRange()"></q-btn>
    </template>
  </div>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import * as moment from "moment";

export default {
  name: "ctk-dater",
  data() {
    const date = new Date()
    return {
      contentStamp: null,
      relativeMonthRange: date.getMonth(),
      runningMonthRange: date.getMonth(),
      nowMonth: date.getMonth(),
      content: {from: null, to: null},
      dateOne: "",
      dateTwo: "",
      months: window.config.locale == "gr" ? ['Ιαν.',
        'Φλεβ.',
        'Μαρτ.',
        'Απριλ.',
        'Μαϊος',
        'Ιουν.',
        'Ιουλ.',
        'Αυγ.',
        'Σεπτ.',
        'Οκτ.',
        'Νοεμ.',
        'Δεκ.'] : ['Jan.',
        'Feb.',
        'Mar.',
        'Apr.',
        'May',
        'June',
        'July',
        'Aug.',
        'Sep.',
        'Oct.',
        'Nov.',
        'Dec.'],
      modalDater: false,
    };
  },
  props: {
    startPlaceholder: {type: String, default: "from"},
    toPlaceholder: {type: String, default: "to"},
    default: {type: String, default: 'fromnow'},
    value: {default: null},
    displayFormat: {
      default: "DD/MM/YYYY", //
    },
    customiseShortcuts: {
      type: Array,
      default: () => null,
    },
    shortcuts: {
      type: Array,
      default: () => [
        {key: "lastWeek", label: "Last week", value: "-isoWeek"},
        {key: "thisWeek", label: "This week", value: "isoWeek"},
        {
          key: "nextWeek",
          label: "Next Week",
          value: () => {
            return {
              from: moment()
                  .add(1, "week")
                  .startOf("week"),
              to: moment()
                  .add(1, "week")
                  .endOf("week"),
            };
          },
        },
        // { key: "last7Days", label: "Last 7 days", value: 7 },
        // { key: "last30Days", label: "Last 30 days", value: 30 },

        {key: "lastMonth", label: "Last month", value: "-month"},
        {key: "thisMonth", label: "This month", value: "month"},
        {
          key: "nextMonth",
          label: "Next Month",
          value: () => {
            return {
              from: moment()
                  .add(1, "month")
                  .startOf("month"),
              to: moment()
                  .add(1, "month")
                  .endOf("month"),
            };
          },
        },
        {key: "lastYear", label: "Last year", value: "-year"},
        {key: "thisYear", label: "This year", value: "year"},

        {
          key: "nextYear",
          label: "Next year",
          value: () => {
            return {
              from: moment()
                  .add(1, "year")
                  .startOf("year"),
              to: moment()
                  .add(1, "year")
                  .endOf("year"),
            };
          },
        },
      ],
    },
    placeholder: {type: String, default: "DD/MM/YYYY"},
    type: {type: String, default: "date"},
    range: {type: Boolean, default: false},
    // withTime: { type: Boolean, default: false },
    exportFormat: {
      default: "DD/MM/YYYY",
    },
    valueFormat: {
      default: "unxtimestamp",
    },
  },
  computed: {
    displayContent: {
      get() {
        let out = "";
        _log_('this.content displayContent', this.content)
        if (!this.content || (!this.content.from && !this.content.to)) return "Ολα";


        if (this.content.from) {
          out = moment(this.content.from, "DD/MM/YYYY")
              .format("DD/MM/YY")
        }

        if (this.content.to) {
          const toDt = moment(this.content.to, "DD/MM/YYYY")
              .format("DD/MM/YY");
          out +=
              "-" +
              toDt;
        }
        return out;
      },
      set(v) {
        if (!v) {
          this.content = {from: null, to: null}
          return
        }
        const vP = v.split('-')
        if (vP[0]) this.content.from = vP[0]
        if (vP[1]) this.content.from = vP[1]
      }
    },
    processedShortcuts() {
      var out = [],
          vm = this;
      if (!this.customiseShortcuts) return this.shortcuts;
      this.customiseShortcuts.forEach((sc) => {
        var existed = vm.findInArray(vm.shortcuts, {key: sc.key});
        if (existed) {
          if (sc.label) existed.label = sc.label;
          if (sc.value) existed.value = sc.value;
        } else {
          if (sc.key && sc.value && sc.label) existed = sc;
          else console.error("Skiiping...Cant add shortcut configuration ", sc);
        }
        if (existed) out.push(existed);
      });
      // _log_("out...", out);
      return out;
    },
    withTime() {
      return this.type != "date";
    },
    elDisplayFormat() {
      if (this.displayFormat.indexOf("/") >= 0) {
        if (this.type == "datetime") return "YYYY-MM-DD hh:mm a";
        return "DD/MM/YYYY";
      }
      return "X";
    },
    elExportFormat() {
      // return "DD/MM/YYYY";
      if (this.exportFormat.indexOf("/") >= 0) {
        if (this.type == "datetime") return "YYYY-MM-DD hh:mm a";
        return "DD/MM/YYYY";
      }
      return "YYYY-MM-DD hh:mm a";
      // _log_("hel.ww..form..", this.valueFormat);
      // if (this.valueFormat == "auto")
      //   return (this.value + "").indexOf("/") > 0
      //     ? "dd/MM/yyyy"
      //     : "unxtimestamp";
      // return this.valueFormat == "unxtimestamp"
      //   ? "timestamp"
      //   : this.valueFormat;
    },
    pickerOptions() {
      var vm = this;
      return {};
    },
  },
  watch: {
    dateOne(value, ov) {
      _log_("hel.DATE.Pa.", value);
    },
    value(val, ov) {
      _log_("DATE value.", val, ov);
      const mf = "DD/MM/YYYY"

      let inVal = null

      if (_.isArray(val) && val.length) {
        inVal = {
          from: val[0] ? moment(val[0], "DD/MM/YYYY")
              .format(mf) : null,
          to: val[1] ? moment(val[1], "DD/MM/YYYY")
              .format(mf) : null,
        };
        _log_("DATE just set content.", val[0], val[1], inVal);
      } else
        inVal =
            val && this.valueFormat == "unxtimestamp"
                ? {from: val[0] * 1000, to: val[1] * 1000}
                : this.value;
      const stmp = JSON.stringify(inVal)
      if (this.contentStamp == stmp) return;
      _log_("DATE set content.", inVal);
      this.content = inVal
      this.contentStamp = stmp
    },

    content(value, oldVal) {
      _log_("DATE content.", value, oldVal);
      const mf = this.exportFormat.indexOf("/") >= 0 ? "DD/MM/YYYY" : "X";
      if (!value && !oldVal) return;
      const stmp = JSON.stringify(this.content)

      if (this.contentStamp == stmp) return;
      this.contentStamp = stmp

      if (value != oldVal) {
        if (this.range) {
          if (!value || (_.isArray(value) && !value.length)) {
            //|| isNaN(value.end) || isNaN(value.from)) {
            // this.$emit("change", [null, null]);
            // this.$emit("input", [null, null]);
            return;
          }
          this.$emit("change", [
            value.from ? value.from : value,// moment(value.from, "YYYY-MM-DD hh:mm a").format(mf),
            value.to ? value.to : value//moment(value.to, "YYYY-MM-DD hh:mm a").format(mf),
          ]);
          this.$emit("input", [
            value.from ? value.from : value,// moment(value.from, "YYYY-MM-DD hh:mm a").format(mf),
            value.to ? value.to : value//moment(value.to, "YYYY-MM-DD hh:mm a").format(mf),
          ]);
        } else {
          if (!value) {
            this.$emit("change", null);
            this.$emit("input", null);
            return;
          }
          this.$emit("change", moment(value, "YYYY-MM-DD hh:mm a")
              .format(mf));
          this.$emit("input", moment(value, "YYYY-MM-DD hh:mm a")
              .format(mf));
        }
      }
    },
  },
  created() {
    _log_('helloooooooooooo', this.default)
    const mf = "DD/MM/YYYY"//this.exportFormat.indexOf("/") >= 0 ? "DD/MM/YYYY" : "X";
    if (this.range) this.content = {from: null, to: null};
    let curentVal = this.value;
    if (_.isArray(curentVal) && !curentVal.length) curentVal = null
    if (this.range && !curentVal)
      if (this.default == "thisyear") {

        this.content = {
          from: moment()
              .startOf("year")
              .format(mf),
          to: moment()
              .endOf("year")
              .format(mf),
        };
        this.$emit("change", [
          this.content.from,
          this.content.to,
        ]);
        this.$emit("input", [
          this.content.from,
          this.content.to
        ]);
        // this.$emit("change", [
        //   moment(this.content.from, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        //   moment(this.content.to, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        // ]);
        // this.$emit("input", [
        //   moment(this.content.from, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        //   moment(this.content.to, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        // ]);

        this.contentStamp = JSON.stringify(this.content)
        return;
      } else if (this.default == "fromnow") {

        this.content = {
          from: moment(new Date())
              .format(mf),
          to: moment(new Date())
              .endOf("year")
              .format(mf),
        };
        this.$emit("change", [
          this.content.from,
          this.content.to,
        ]);
        this.$emit("input", [
          this.content.from,
          this.content.to
        ]);
        // this.$emit("change", [
        //   moment(this.content.from, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        //   moment(this.content.to, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        // ]);
        // this.$emit("input", [
        //   moment(this.content.from, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        //   moment(this.content.to, "YYYY-MM-DD hh:mm a")
        //       .format(mf),
        // ]);

        this.contentStamp = JSON.stringify(this.content)
        return;
      } else if (this.default == "4months") {

        this.content = {
          to: moment(new Date())
              .format(mf),
          from: moment()
              .subtract(4, 'M')
              .format(mf),
        };
        _log_('init date this.default', this.default, this.content)
        this.$emit("change", [
          this.content.from,
          this.content.to,
        ]);
        this.$emit("input", [
          this.content.from,
          this.content.to
        ]);

        this.contentStamp = JSON.stringify(this.content)
        return;
      } else if (this.default == "2months") {
        _log_('oooooooooo',)
        this.content = {
          from: moment(new Date())
              .format(mf),
          to: moment()
              .add(2, 'M')
              .format(mf),
        };
        _log_('init date this.default', this.default, this.content)
        this.$emit("change", [
          this.content.from,
          this.content.to,
        ]);
        this.$emit("input", [
          this.content.from,
          this.content.to
        ]);

        this.contentStamp = JSON.stringify(this.content)
        return;
      }
    if (!this.range) {
      if (this.valueFormat == "unxtimestamp")
        this.content = moment.unix(curentVal)
            .format("YYYY-MM-DD hh:mm a");
      else
        this.content = moment(curentVal, "DD/MM/YYYY")
            .format(
                "YYYY-MM-DD hh:mm a"
            );
    } else {
      if (_.isArray(curentVal) && curentVal.length) {
        this.content = {
          from: moment(curentVal[0], "DD/MM/YYYY")
              .format(mf),
          to: moment(curentVal[1], "DD/MM/YYYY")
              .format(mf),
        };
        this.$emit("input", [this.content.from,
          this.content.to]);
        this.$emit("change", [this.content.from,
          this.content.to]);
      } else
        this.content =
            curentVal && this.valueFormat == "unxtimestamp"
                ? {from: curentVal[0] * 1000, to: curentVal[1] * 1000}
                : curentVal;
    }
    this.contentStamp = JSON.stringify(this.content)
    // this.content = [date.getTime(), date.getTime()];
  },
  methods: {
    lastSelect(e) {
      _log_('ranger........', e)
    },
    goRange(where, yearMode) {
      const date = new Date()
      const formatDate = "DD/MM/YYYY";
      if (where === false) {
        this.content = null
        this.$emit("change", [null,
          null]);
        this.$emit("input", [null,
          null]);
        return
      }
      if (!yearMode) {
        this.runningMonthRange = where ? this.runningMonthRange + where : date.getMonth()
        // this.runningMonthRange = this.runningMonthRange > 11 ? 0 : this.runningMonthRange
        let y = parseInt(date.getFullYear()), m = this.runningMonthRange;
        // if (this.content && this.content.from) y = parseInt(moment(this.content.from, "DD/MM/YYYY").format(
        //     "YYYY"
        // ))
        const yearOffset = Math.floor(this.runningMonthRange / 12), monthOffset = this.runningMonthRange % 12
        // m = monthOffset
        this.relativeMonthRange = monthOffset >= 0 ? monthOffset : 12 + monthOffset
        y += parseInt(yearOffset)
        _log_('yearOffset', this.runningMonthRange, this.relativeMonthRange, y, yearOffset, monthOffset)
        let firstDay = new Date(y, this.relativeMonthRange, 1);
        let lastDay = new Date(y, this.relativeMonthRange + 1, 0);


        this.content = {
          from: moment(firstDay)
              .format(formatDate),
          to: moment(lastDay)
              .format(formatDate)
        }
      } else {
        let y = date.getFullYear();
        y += where
        let firstDay = new Date(y, 0, 1);
        let lastDay = new Date(y, 12, 0);


        this.content = {
          from: moment(firstDay)
              .format(formatDate),
          to: moment(lastDay)
              .format(formatDate)
        }
      }
    },
    setRange(a, b) {
      if (a) this.content = {to: this.content.to, from: a};
      if (b) this.content = {from: this.content.from, to: b};

    },
    updateModel(val) {
      this.$emit("change", [val.from,
        val.to]);
      this.$emit("input", [val.from,
        val.to]);
    },
    init() {
    },
  },
};
</script>
<style>
button.range-btn {
  padding-left: 0px;
  padding-right: 2px;
  font-size: 11px;
  color: white;
  margin: 0px;
}

div.myMobModal {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 5000;
  background-color: #032117;
}

.el-range-editor--medium.el-input__inner {
  height: 42px;
}

div.date-time-picker div input {
  background-color: transparent !important;
  color: whitesmoke !important;
}

.range-wrapper {
  padding-left: 2px;
  padding-bottom: 2px;
}

div.date-time-picker div label {
  background-color: transparent !important;
  color: wheat !important;
}

.datepicker-button-effect,
.custom-button-effect,
.datepicker-day-effect,
.header-picker {
  background: #095b69 !important;
}

.range-btn span.q-btn__content {
  font-size: small;
  color: #ffffff;

}

.range-btn span.q-btn__content i.on-left {
  margin: 0px;
}

.range-btn span.q-btn__content span.block {
  font-size: 11px;
  color: #ffffff;
  font-weight: bold;
  overflow: hidden;
}

.datepicker-button,
.custom-button,
.datepicker-buttons-container,
.pickers-container {
  background: #009688 !important;
}

.custom-button-content {
  color: #ffffff !important;
}

.datepicker-buttons-container .datepicker-button {
  background: #077083 !important;
  border: none !important;
}

.datepicker-buttons-container .datepicker-button svg {
  fill: #ffffff !important;
}
</style>
